module.exports = __webpack_public_path__ + "img/md-wojak.2928f475.jpeg";